<template>
  <section id="Partners">
    <section class="affiliates mb-50">
      <h2 class="h3 text-center mb-50">關係企業</h2>
      <div class="row">
        <div class="col-lg-2 d-lg-block d-none my-15"></div>
        <div class="col-lg-2 col-md-3 col-4 my-15" v-for="(item,index) in affiliates" :key="index">
          <a :href="item.link" target="_blank">
            <div
              class="store"
              v-lazy:background-image="require(`@/assets/affiliates/${item.name}.png`)"
            ></div>
          </a>
        </div>
      </div>
    </section>
    <section class="collaboration pb-50" style="display:none">
      <h2 class="h3 text-center mb-40">合作商家</h2>
      <div class="row">
        <div
          class="col-lg-2 col-md-3 col-4 my-15"
          v-for="(item, index) in collaboration"
          :key="index"
        >
          <a :href="item.link" target="_blank">
            <div
              class="store"
              v-lazy:background-image="require(`@/assets/collaboration/${item.img}.png`)"
            ></div>
            <p class="text-center">{{item.name}}</p>
          </a>
        </div>
      </div>
    </section>
  </section>
</template>
<script>
export default {
  name: 'Partners',
  data() {
    return {
      affiliates: [
        { name: 'department', link: 'https://www.hanshin.com.tw/tw' },
        { name: 'hi-lai-food', link: 'http://www.hilai-foods.com/zh_TW' },
        { name: 'hotel', link: 'https://www.grand-hilai.com/' },
        { name: 'guoyang', link: 'https://www.kycc.com.tw/tw/' },
      ],
      collaboration: [
        { img: 'muxuan', name: '牧軒刷物鍋', link: 'https://www.facebook.com/muxuanshabu' },
        {
          img: 'sweetme',
          name: '水美溫泉會館',
          link: 'https://www.facebook.com/sweetMehotspring/',
        },
        { img: 'monster', name: '路地氷の怪物', link: 'https://www.facebook.com/rojitaiwan/' },
        {
          img: 'le-petit',
          name: '小間咖啡',
          link:
            'https://www.facebook.com/%E5%B0%8F%E9%96%93%E5%92%96%E5%95%A1%E9%85%92%E9%A4%A8-Le-Petit-Caf%C3%A9-1144618718888598/',
        },
        { img: 'moon', name: '微笑月亮', link: 'https://www.facebook.com/smilemoon2019/' },
        { img: 'ramen', name: '竹拉麵', link: 'https://www.facebook.com/20191108open/' },
        { img: 'youngji', name: '萬象小吃店', link: 'https://www.facebook.com/wenyungji/' },
        { img: 'weiwei', name: '等等食行', link: 'https://www.facebook.com/wait.weiwei/' },
        { img: 'fullofcacti', name: '肉滿堂', link: 'https://www.facebook.com/fullofcacti/' },
        { img: 'papaya', name: '潘雅', link: 'https://www.facebook.com/papaya23/' },
        { img: 'homeplus', name: '中嘉', link: 'https://www.homeplus.net.tw/discount-plan-detail-44_3_5.html?utm_source=H%27SVIBE&utm_medium=APP' },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
#Partners {
  padding: 20px 0 30px;
  .row {
    .store {
      position: relative;
      width: 100%;
      height: 150px;
      background-size: cover;
      background-position: center bottom;
      border-radius: 10px;
    }
  }
}
</style>
